let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("qMTFl")).then(() => parcelRequire('jgLAY'));